<div class="form-wrapper">
    <mat-grid-list [cols]="18" gutterSize="25px" rowHeight="360px" class="grid-list-space">
        <mat-grid-tile class="align-items-inherit container" [colspan]="leftMenuToggle ? 6 : 1">
            <mat-card style="margin-top: -30px;">
                <div class="row justify-content-end">
                    <button mat-icon-button aria-label="Open/Close general info left area" class="mr-3"
                        (click)="leftMenuToggle = !leftMenuToggle" (keydown.enter)="leftMenuToggle = !leftMenuToggle">
                        <mat-icon>{{leftMenuToggle ? 'chevron_left' : 'chevron_right'}}</mat-icon>
                    </button>
                </div>
                <div class="row " [ngStyle]="{'visibility': leftMenuToggle ? 'visible' : 'hidden'}">
                    <div class="col-11 custom-input-wrapper">
                        <custom-input label="PR Date:" [inline]="true" [readonly]="true" [value]="selectedTpr.prDate"
                            format="date:M/d/y"
                            [disabled]="disabled || reSourced || inActive || !fieldAuthorized('prDate')"></custom-input>
                        <custom-dropdown [data]="sources.designSources" label="Design Source:" [inline]="true"
                            [value]="selectedTpr?.designSourceId" valueField="id" textField="sourceName"
                            [disabled]="disabled || reSourced || inActive || !fieldAuthorized('designSourceId')"
                            (selectionChange)="onDesignSourceSelectionChange($event)">
                        </custom-dropdown>
                        <custom-dropdown [data]="sources.constSources" label="Const Source:" [inline]="true"
                            [value]="selectedTpr?.constSourceId" valueField="id" textField="sourceName"
                            [disabled]="disabled || reSourced || inActive || !fieldAuthorized('constSourceId')"
                            (selectionChange)="onConstSourceSelectionChange($event)">
                        </custom-dropdown>
                        <custom-dropdown [data]="sources.firstUserSources" label="1st User Source:" [inline]="true"
                            [value]="selectedTpr?.firstUserSourceId" valueField="id" textField="sourceName"
                            [disabled]="disabled || reSourced || inActive || !fieldAuthorized('firstUserSourceId')"
                            (selectionChange)="onFirstUserSourceSelectionChange($event)">
                        </custom-dropdown>
                        <custom-dropdown [data]="sources.userSources" label="User Source:" [inline]="true"
                            [value]="selectedTpr?.userSourceId" valueField="id" textField="sourceName"
                            [disabled]="disabled || reSourced || inActive || !fieldAuthorized('userSourceId')"
                            (selectionChange)="onUserSourceSelectionChange($event)">
                        </custom-dropdown>
                        <custom-dropdown [data]="sources.fixtureLocs" label="Fixture Loc:" [inline]="true"
                            [value]="selectedTpr?.fixtLocId" valueField="id" textField="sourceName"
                            [disabled]="disabled || reSourced || inActive || !fieldAuthorized('fixtLocId')"
                            (selectionChange)="onFixtureLocSelectionChange($event)">
                        </custom-dropdown>
                    </div>
                </div>
            </mat-card>
        </mat-grid-tile>
        <mat-grid-tile class="align-items-inherit" colspan="6">
            <mat-card>
                <div class="display-style">
                    <span class="label-wrapper">
                        <mat-label>Const Complete:</mat-label>
                    </span>
                    <mat-form-field class="no-underline body-wrapper block-formfield">
                        <input class="input-wrapper" matInput (ngModel)="selectedTpr.buildSchedFinish"
                            [ngModel]="selectedTpr.designOnly ? '' :selectedTpr.buildSchedFinish | date:'M/d/y'"
                            readonly
                            [disabled]="disabled || reSourced || inActive || !fieldAuthorized('buildSchedFinish')" />
                    </mat-form-field>
                </div>

                <div class="display-style">
                    <span class="label-wrapper">
                        <mat-label>1st User Req:</mat-label>
                    </span>
                    <mat-form-field class="partial-block-formfield">
                        <input matInput class="input-wrapper" [matDatepicker]="firstUserReqDatepicker"
                            (dateChange)="onFirstUserReqDateChange()" [(ngModel)]="selectedTpr.fixtureRequired"
                            [disabled]="disabled || reSourced || inActive || !fieldAuthorized('fixtureRequired')"
                            required />
                        <mat-datepicker-toggle matSuffix [for]="firstUserReqDatepicker"></mat-datepicker-toggle>
                        <mat-datepicker #firstUserReqDatepicker></mat-datepicker>
                    </mat-form-field>
                    <mat-checkbox class="checkbox-format checkbox  checkbox-lmargin" color="primary"
                        [(ngModel)]="selectedTpr.overrideTm" (ngModelChange)="onFirstUserReqCheckChange()" disableRipple
                        [disabled]="disabled || reSourced || inActive || !fieldAuthorized('overrideTm')">
                    </mat-checkbox>
                </div>

                <div class="display-style">
                    <span *ngIf="!selectedTpr.designOnly" class="label-wrapper ">
                        <mat-label>TMaCs CF Req:</mat-label>
                    </span>
                    <mat-form-field *ngIf="!selectedTpr.designOnly" class="no-underline body-wrapper block-formfield"
                        [ngClass]="{'no-underline-bg-red': selectedTpr.chgCfReq}">
                        <input matInput class="input-wrapper" [ngModel]="selectedTpr.tmacsCfRqd | date:'M/d/y'"
                            (ngModel)="selectedTpr.tmacsCfRqd" readonly
                            [disabled]="disabled || reSourced || inActive || !fieldAuthorized('tmacsCfRqd')" />
                    </mat-form-field>
                </div>

                <div class="display-style">
                    <span class="label-wrapper ">
                        <mat-label>R-Study Sched:</mat-label>
                    </span>
                    <mat-form-field *ngIf="!this.selectedTpr.revisionTpr; else RStudyNR"
                        class="no-underline body-wrapper block-formfield">
                        <input matInput class="input-wrapper" (ngModel)="selectedTpr.fmtRStudyScheduleDate"
                            [ngModel]="selectedTpr.fmtRStudyScheduleDate | date:'M/d/y'" readonly
                            [disabled]="disabled || reSourced || inActive || !fieldAuthorized('fmtRStudyScheduleDate')" />
                    </mat-form-field>
                    <ng-template #RStudyNR>
                        <span class="label-wrapper">
                            <mat-label>N/R</mat-label>
                        </span>
                    </ng-template>
                </div>

                <div class="display-style">
                    <span class="label-wrapper">
                        <mat-label>R-Study Passing:</mat-label>
                    </span>
                    <mat-form-field *ngIf="selectedTpr.na1 && !this.selectedTpr.revisionTpr"
                        class="no-underline  body-wrapper partial-block-formfield">
                        <input matInput class="input-wrapper" value="N/A" readonly
                            [disabled]="disabled || reSourced || inActive" />
                    </mat-form-field>
                    <mat-form-field *ngIf="!selectedTpr.na1 && !this.selectedTpr.revisionTpr"
                        class="block partial-block-formfield">
                        <input matInput class="input-wrapper" [matDatepicker]="rStudyPassingDatePicker"
                            (dateChange)="onRStudyPassingDateChange()" [(ngModel)]="selectedTpr.rStudyActualDate"
                            [disabled]="disabled || reSourced || inActive || !fieldAuthorized('rStudyActualDate')" />
                        <mat-datepicker-toggle matSuffix [for]="rStudyPassingDatePicker"></mat-datepicker-toggle>
                        <mat-datepicker #rStudyPassingDatePicker></mat-datepicker>
                    </mat-form-field>
                    <mat-checkbox *ngIf="!this.selectedTpr.revisionTpr; else RStudyPassingNR"
                        class="checkbox-format checkbox checkbox-lmargin" color="primary" [(ngModel)]="selectedTpr.na1"
                        (ngModelChange)="onRStudyPassingCheckChange()" disableRipple
                        [disabled]="disabled || reSourced || inActive || !fieldAuthorized('na1')">
                    </mat-checkbox>
                    <ng-template #RStudyPassingNR>
                        <span class="label-wrapper">
                            <mat-label>N/R</mat-label>
                        </span>
                    </ng-template>
                </div>

                <div class="display-style">
                    <span class="label-wrapper">
                        <mat-label>R-Study Adj (days):</mat-label>
                    </span>
                    <searchable-autocomplete style="margin-top: -12px;" class="block-formfield"
                        *ngIf="!this.selectedTpr.revisionTpr; else RStudyAdjNR" [options]="rStudyAdjList"
                        [exactMatch]="false" [numberInput]="true" filterBy="rStudyAdj"
                        [(selected)]="selectedTpr.rStudyWeeksAdj" (select)="onRStudyAdjSelectionChange()"
                        [disabled]="disabled || reSourced || inActive || !fieldAuthorized('rstudyWeeksAdj')">
                    </searchable-autocomplete>
                    <ng-template #RStudyAdjNR>
                        <span class="label-wrapper">
                            <mat-label>N/R</mat-label>
                        </span>
                    </ng-template>
                </div>

                <div style="height: 20px;">
                    <div class="checkbox-text ">Design Only</div>
                    <mat-checkbox class="checkbox-format checkbox-6b" color="primary"
                        [(ngModel)]="selectedTpr.designOnly" (ngModelChange)="onDesignOnlyCheckChange()" disableRipple
                        [disabled]="disabled || reSourced || inActive || !fieldAuthorized('designOnly')">
                    </mat-checkbox>
                </div>
                <div style="height: 20px;">
                    <div class="checkbox-text">Build Quote</div>
                    <mat-checkbox class="checkbox-format checkbox-3b" color="primary"
                        [(ngModel)]="selectedTpr.quotePrice" (ngModelChange)="onBuildQuoteCheckChange()"
                        [disabled]="this.selectedTpr.designOnly || disabled || inActive || !fieldAuthorized('quotePrice')"
                        labelPosition="after" disableRipple>Best Price</mat-checkbox>
                </div>
                <div style="height: 20px;">
                    <div class="checkbox-text">Rationale</div>
                    <mat-checkbox class="checkbox-format checkbox-3b" color="primary"
                        [(ngModel)]="selectedTpr.quoteTiming" (ngModelChange)="onRationaleCheckChange()"
                        [disabled]="this.selectedTpr.designOnly || disabled || inActive || !fieldAuthorized('quoteTiming')"
                        labelPosition="after" disableRipple>Best Timing</mat-checkbox>
                </div>
            </mat-card>
        </mat-grid-tile>
        <mat-grid-tile class="align-items-inherit" colspan="6">
            <mat-card>
                <div class="display-style">
                    <span class="label-wrapper">
                        <mat-label>Gage Design(%):</mat-label>
                    </span>
                    <mat-form-field class="no-underline body-wrapper block-formfield">
                        <input matInput class="input-wrapper" [(ngModel)]="selectedTpr.gaDesign" readonly
                            [disabled]="disabled || reSourced || inActive || !fieldAuthorized('gaDesign')" />
                    </mat-form-field>
                </div>

                <div class="display-style">
                    <span class="label-wrapper">
                        <mat-label>Gage Build(%):</mat-label>
                    </span>
                    <mat-form-field class="no-underline body-wrapper block-formfield">
                        <input matInput class="input-wrapper" [(ngModel)]="selectedTpr.gaBuild" readonly
                            [disabled]="disabled || reSourced || inActive || !fieldAuthorized('gaBuild')" />
                    </mat-form-field>
                </div>

                <div class="display-style">
                    <span class=" label-wrapper">
                        <mat-label>Risk 1st User:</mat-label>
                    </span>
                    <mat-form-field class="partial-block-formfield body-wrapper no-underline" [ngClass]="{
                     'bg-green': getRisk1Calc() === RiskType.GREEN, 
                     'bg-red': getRisk1Calc() === RiskType.RWOP || getRisk1Calc() === RiskType.RWP }">
                        <input matInput class="input-wrapper" [value]="getRisk1Calc()" readonly
                            [disabled]="disabled || reSourced || inActive || !fieldAuthorized('r1')" />
                    </mat-form-field>
                    <mat-checkbox class="checkbox-format checkbox checkbox-lmargin" color="primary"
                        [(ngModel)]="this.selectedTpr.r1" (ngModelChange)="onRiskFirstUserCheckChange()" disableRipple
                        [disabled]="disabled || reSourced || inActive || !fieldAuthorized('r1')">
                    </mat-checkbox>
                </div>

                <div class="display-style">
                    <span class=" label-wrapper">
                        Arrv 1st User:
                    </span>
                    <mat-form-field class="block-formfield">
                        <input matInput class="input-wrapper" [matDatepicker]="arrvFirstUserDatePicker"
                            (dateChange)="onArrvFirstUserDateChange()" [(ngModel)]="selectedTpr.arrvTryout"
                            [disabled]="disabled || reSourced || inActive " />
                        <mat-datepicker-toggle matSuffix [for]="arrvFirstUserDatePicker"
                            [disabled]="disabled || reSourced || inActive ||!fieldAuthorized('arrvTryout')">
                        </mat-datepicker-toggle>
                        <mat-datepicker #arrvFirstUserDatePicker></mat-datepicker>
                    </mat-form-field>
                </div>

                <div class="display-style">
                    <span class=" label-wrapper">
                        Arrv User Source:
                    </span>
                    <mat-form-field class="block-formfield"
                        matTooltip="Before entering an Arrv User Source date, enter an Arrv 1st User date or select NONE for 1st User Source.  In addition, it is necessary to enter an R-Study Passing date or enter N/A for R-Study Passing field.">
                        <input matInput class="input-wrapper" [matDatepicker]="arrvUserSourceDatePicker"
                            (dateChange)="onArrvUserSourceDateChange()" [(ngModel)]="selectedTpr.arrvUserSrc"
                            [disabled]="disabled || !firstUserDateEnabled() || reSourced || inActive " />
                        <mat-datepicker-toggle matSuffix [for]="arrvUserSourceDatePicker"
                            [disabled]="disabled || reSourced || inActive || !fieldAuthorized('arrvUserSrc')">
                        </mat-datepicker-toggle>
                        <mat-datepicker #arrvUserSourceDatePicker></mat-datepicker>
                    </mat-form-field>
                </div>

                <div class="display-style">
                    <span class="label-wrapper">
                        <mat-label>Die Type:</mat-label>
                    </span>
                    <mat-form-field *ngIf="dieTypeEnabled()" class="block block-formfield">
                        <mat-select class="drop-down" [(ngModel)]="selectedTpr.progMake"
                            (selectionChange)="onDieTypeChange()"
                            [disabled]="disabled || reSourced || inActive || !fieldAuthorized('progMake')">
                            <mat-option [value]="'Prog Die'">Prog Die</mat-option>
                            <mat-option [value]="'Make Die'">Make Die</mat-option>
                        </mat-select>
                    </mat-form-field>
                    <mat-form-field *ngIf="!dieTypeEnabled()" class="no-underline body-wrapper block-formfield">
                        <input matInput class="input-wrapper" value="N/A" readonly
                            [disabled]="disabled || reSourced || inActive" />
                    </mat-form-field>
                </div>
            </mat-card>
        </mat-grid-tile>
    </mat-grid-list>
</div>